const common = {
  home: '首页',
  category: '分类',
  about: '关于我们',
  search: '搜索',
  searchPlaceholder: '搜索文章、教程、问题...',
  readMore: '阅读全文',
  viewAll: '查看全部',
  latestArticles: '最新文章',
  featuredArticles: '精选推荐',
  relatedArticles: '相关文章',
  categories: '文章分类',
  allCategories: '全部分类',
  articleCount: '篇文章',
  readTime: '阅读时间',
  views: '次阅读',
  publishedOn: '发布于',
  author: '作者',
  tags: '标签',
  breadcrumbHome: '首页',
  backToTop: '返回顶部',
  noArticles: '暂无文章',
  contactUs: '联系我们',
  email: '电子邮箱',
  phone: '联系电话',
  address: '公司地址',
  workingHours: '工作时间',
  brandIntro: '品牌介绍',
  reputation: '平台信誉',
  quickLinks: '快速链接',
  followUs: '关注我们',
  copyright: '版权所有',
  allRightsReserved: '保留所有权利',
  faqTitle: '常见问题',
  faqSubtitle: '快速找到您想要的答案',
  aboutTitle: '关于 g点网',
  aboutSubtitle: '值得信赖的综合性网络服务平台',
  siteDescription: 'g点网致力于为用户提供安全、便捷、高效的网络服务体验。我们汇聚优质内容，打造开放社区，守护用户安全。',
  heroTitle: 'g点网 - 您的综合网络服务平台',
  heroSubtitle: '汇聚海量优质内容，提供安全便捷的在线服务。无论是资讯浏览、功能使用还是安全防护，g点网都是您最值得信赖的选择。',
  heroCta: '立即探索',
  heroCtaSecondary: '了解更多',
  statsUsers: '活跃用户',
  statsArticles: '优质内容',
  statsSatisfaction: '用户满意度',
  statsYears: '年运营经验',
  newsletterTitle: '订阅我们的资讯',
  newsletterSubtitle: '第一时间获取g点网最新动态和实用教程',
  newsletterPlaceholder: '请输入您的邮箱地址',
  newsletterButton: '订阅',
  subscribeSuccess: '订阅成功！感谢您的关注。',
};

export default common;